export function ErrorMessages(name) {
    const messages = {
        undefined: `${name} is not defined`
    };
    if (name) {
        return messages;
    }
}
//# sourceMappingURL=error-messages.func.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@angular-package/change-detection/decorator/src/error-messages.func.js
// module id = 908
// module chunks = 7